import React, { useState, useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { css } from '@emotion/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useRootStore } from '../../../stores/BridgeProvider';
import { FlexDiv, StandardBox } from '../../styles/styles';
import { useSnackBars } from '../../../alerts/SnackBarProvider';
import { COLORS } from '../../util/Colors';

const SyncInProgress = () => {
  const history = useHistory();
  const { state } = useLocation();
  const { authStore, orgStore } = useRootStore();
  const [emptyArrayCount, setEmptyArrayCount] = useState(0);
  const [syncInfo, setSyncInfo] = useState([]);
  const [needsOrgDefaults, setNeedsOrgDefaults] = useState(null);
  const [callingOrgDefaults, setCallingOrgDefaults] = useState(false);
  const handleAlert = useSnackBars();
  const intRef = useRef(null);
  const { settings } = orgStore;

  console.log(syncInfo);

  const syncItemRow = css`
    display: flex;
    justify-content: space-between;
  `;

  useEffect(() => {
    const { syncDateTime } = state || {};
    const syncStartTime = syncDateTime || new Date();

    const getSyncInfo = async () => {
      try {
        const { data } = await authStore.request.get(
          `${process.env.REACT_APP_API}/api/xero-sync-status`,
          {
            params: {
              syncStartTime,
            },
          },
        );

        if (!Array.isArray(data) || !data.length) {
          setEmptyArrayCount(curVal => curVal + 1);
        } else if (emptyArrayCount > 0) {
          setEmptyArrayCount(0);
        }
        setSyncInfo(data);
      } catch (e) {
        setSyncInfo(['ERROR']);
      }
    };
    getSyncInfo();
    intRef.current = setInterval(() => getSyncInfo(), 2000);
    return () => {
      clearInterval(intRef.current);
    };
  }, []);

  useEffect(() => {
    const getOrgStatus = async () => {
      try {
        const { data } = await authStore.request.get(
          `${process.env.REACT_APP_API}/api/organization-status`,
          {
            params: {
              orgId: settings.OrgId,
            },
          },
        );

        setNeedsOrgDefaults(data.StatusId);
      } catch (e) {
        console.log(e);
      }
    };
    getOrgStatus();
  }, []);

  const setOrgDefaults = async () => {
    if (!callingOrgDefaults) {
      setCallingOrgDefaults(true);
      try {
        await authStore.request.post(
          `${process.env.REACT_APP_API}/api/org-defaults`,
          {
            orgId: settings.OrgId,
          },
        );

        // get new config with defaults
        orgStore.retrieveConfig();

        history.push('/dashboard');
      } catch (e) {
        console.log(e);
      }
      setCallingOrgDefaults(false);
    }
  };

  if (emptyArrayCount > 8) {
    history.push('/dashboard');
    handleAlert(
      'There seems to be an issue syncing your org. If this issue persists you can manually reauthenticate with xero',
      COLORS.orange,
    );
  }
  const isDone = (() =>
    syncInfo.every(({ Status }) => Status && Status === 'Finished') ||
    syncInfo === ['ERROR'])();

  if (syncInfo.length > 0 && isDone) {
    clearInterval(intRef.current);
    if (needsOrgDefaults === 0) {
      setOrgDefaults();
    } else {
      history.push('/dashboard');
    }
  }

  return (
    <FlexDiv>
      <StandardBox>
        <h2>We are syncing Xero data to your organization</h2>
        <h4>You will be redirected when finished</h4>
        {syncInfo.length === 0 && (
          <div style={{ marginTop: '15px' }}>
            <CircularProgress size="2.5rem" color="primary" />
          </div>
        )}
        <div>
          {syncInfo.map(
            ({ ObjectTypeDesc: objName, Status: objStatus, Count: objCount }) =>
              objCount !== null ? (
                <div css={syncItemRow} key={objName}>
                  <p>{objName}</p>
                  <p>
                    {objStatus === 'Finished' ? (
                      `${objCount} synced`
                    ) : (
                      <CircularProgress size="1rem" color="primary" />
                    )}
                  </p>
                </div>
              ) : null,
          )}
        </div>
      </StandardBox>
    </FlexDiv>
  );
};

export default SyncInProgress;
